import { Document, Font } from '@react-pdf/renderer'
import isEmpty from 'lodash/isEmpty'
import { useRef } from 'react'
// import Chapter1Page from './Pages/Phish/Chapter1Page'
// import Chapter2Page from './Pages/Phish/Chapter2Page'
// import Chapter3Page from './Pages/Phish/Chapter3Page'
// import Chapter3Sub1Page from './Pages/Phish/Chapter3Sub1Page'
// import Chapter3Sub2Page from './Pages/Phish/Chapter3Sub2Page'
// import Chapter4Page from './Pages/Phish/Chapter4Page'
// import Chapter4Sub1Page from './Pages/Phish/Chapter4Sub1Page'
// import Chapter4Sub2Page from './Pages/Phish/Chapter4Sub2Page'
// import Chapter4Sub3Page from './Pages/Phish/Chapter4Sub3Page'
// import CoverPage from './Pages/Phish/CoverPage'
// import DisclaimerPage from './Pages/Phish/DisclaimerPage'
// import TableOfContentsPage from './Pages/Phish/TableOfContentsPage'
import Chapter1Page from './Pages/PhishPro/Chapter1Page'
import Chapter2Page from './Pages/PhishPro/Chapter2Page'
import Chapter3Page from './Pages/PhishPro/Chapter3Page'
import Chapter3Sub1Page from './Pages/PhishPro/Chapter3Sub1Page'
import Chapter3Sub2Page from './Pages/PhishPro/Chapter3Sub2Page'
import Chapter4Page from './Pages/PhishPro/Chapter4Page'
import Chapter4Sub1Page from './Pages/PhishPro/Chapter4Sub1Page'
import Chapter4Sub2Page from './Pages/PhishPro/Chapter4Sub2Page'
import Chapter4Sub3Page from './Pages/PhishPro/Chapter4Sub3Page'
import Chapter4Sub4Page from './Pages/PhishPro/Chapter4Sub4Page'
import Chapter4Sub5Page from './Pages/PhishPro/Chapter4Sub5Page'
import Chapter4Sub6Page from './Pages/PhishPro/Chapter4Sub6Page'
import Chapter4Sub7Page from './Pages/PhishPro/Chapter4Sub7Page'
import Chapter4Sub8Page from './Pages/PhishPro/Chapter4Sub8Page'
import Chapter4Sub9Page from './Pages/PhishPro/Chapter4Sub9Page'
// import Chapter4Sub10Page from './Pages/PhishPro/Chapter4Sub10Page'
// import Chapter4Sub11Page from './Pages/PhishPro/Chapter4Sub11Page'
import Chapter5Page from './Pages/PhishPro/Chapter5Page'
import CoverPage from './Pages/PhishPro/CoverPage'
import DisclaimerPage from './Pages/PhishPro/DisclaimerPage'
import TableOfContentsPage from './Pages/PhishPro/TableOfContentsPage'
import BiauKai from '../../assets/fonts/edukai-5.0.ttf'

Font.register({
  family: 'Noto Sans',
  fonts: [
    { src: `${process.env.PUBLIC_URL}/fonts/NotoSansTC-Regular.ttf` },
    { src: `${process.env.PUBLIC_URL}/fonts/NotoSansTC-Bold.ttf`, fontWeight: 700 },
  ],
})

Font.register({
  family: 'BiauKai',
  fonts: [{ src: BiauKai }],
})

Font.registerHyphenationCallback(word => Array.from(word).flatMap(char => [char, '']))

const ReportDocument = ({
  donutChartImg,
  pageData = {},
  reportData,
  onRender,
  pieChartImg,
  pieChart2Img,
  barChart2Img,
  barChart3Img,
  barChart4Img,
}) => {
  const localPageData = useRef(pageData)

  const setPage = page => {
    if (isEmpty(pageData)) {
      const prevData = localPageData.current
      localPageData.current = { ...prevData, ...page }
    }
  }

  // const shouldRenderOfficePage = reportData.officeReportGroups.length > 0
  const shouldRenderHistoriesPage = reportData.reprotHistories.length > 1

  return (
    <Document
      style={{ wordBreak: 'break-all' }}
      onRender={() => {
        onRender?.({ pageData: localPageData.current })
      }}
    >
      <CoverPage reportData={reportData} />
      <DisclaimerPage reportData={reportData} />
      <TableOfContentsPage
        pageData={pageData}
        reportData={reportData}
        shouldRenderHistoriesPage={shouldRenderHistoriesPage}
      />
      <Chapter1Page setPage={setPage} reportData={reportData} />
      <Chapter2Page setPage={setPage} reportData={reportData} />
      <Chapter3Page setPage={setPage} reportData={reportData} />
      <Chapter3Sub1Page setPage={setPage} reportData={reportData} />
      <Chapter3Sub2Page setPage={setPage} reportData={reportData} />
      <Chapter4Page setPage={setPage} reportData={reportData} />
      <Chapter4Sub1Page setPage={setPage} chartImg1={donutChartImg} reportData={reportData} />
      <Chapter4Sub2Page setPage={setPage} reportData={reportData} />
      <Chapter4Sub3Page setPage={setPage} chartImg3={barChart3Img} reportData={reportData} />
      <Chapter4Sub4Page setPage={setPage} chartImg4={barChart4Img} reportData={reportData} />
      <Chapter4Sub5Page setPage={setPage} reportData={reportData} />
      {/* {shouldRenderOfficePage ? (
        <Chapter4Sub6Page setPage={setPage} chartImg5={pieChartImg} reportData={reportData} />
      ) : (
        []
      )}
      <Chapter4Sub7Page
        setPage={setPage}
        chartImg6={pieChart2Img}
        reportData={reportData}
        shouldRenderOfficePage={shouldRenderOfficePage}
      /> */}
      {shouldRenderHistoriesPage ? (
        <Chapter4Sub8Page setPage={setPage} reportData={reportData} />
      ) : (
        []
      )}
      {shouldRenderHistoriesPage ? (
        <Chapter4Sub9Page setPage={setPage} chartImg2={barChart2Img} reportData={reportData} />
      ) : (
        []
      )}
      {/* <Chapter4Sub10Page
        setPage={setPage}
        reportData={reportData}
        shouldRenderOfficePage={shouldRenderOfficePage}
      />
      <Chapter4Sub11Page
        setPage={setPage}
        reportData={reportData}
        shouldRenderOfficePage={shouldRenderOfficePage}
      /> */}
      <Chapter5Page setPage={setPage} reportData={reportData} />
    </Document>
  )
}

export default ReportDocument
